import { TypeM3PrdGrp } from "./M3PrdGrp.type";
import { M3PItemsWEB } from "../Registro/m3-pdetalle-items";

export class M3PrdPackDet {
    public LOTE: string;
    public LOTEHIJO: string;
    public SKUHIJO: string;
    public Cantidad: number;
    public TipoPack: string;
    public gsPathImagen: string;
    public oM3PItemsWEB: M3PItemsWEB;
    public M3GRP = new TypeM3PrdGrp();
    public Orden: number;
    public IdGrp: string;

}